// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

@media (max-width: 768px) {
  /* 表格适配 */
  .ant-table {
    overflow-x: auto;
    display: block;
  }

  /* 模态框宽度 */
  .ant-modal {
    width: 95% !important;
    max-width: 100%;
    margin: 10px;
  }

  /* 卡片布局 */
  .user-card .ant-card-body {
    padding: 12px;
  }
  
  .user-card .ant-card-cover {
    padding: 5px;
  }
}

/* 手机端表格滚动 */
.table-responsive {
  overflow-x: auto;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,SAAS;EACT;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA,UAAU;EACV;IACE,qBAAqB;IACrB,eAAe;IACf,YAAY;EACd;;EAEA,SAAS;EACT;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,YAAY;AACZ;EACE,gBAAgB;AAClB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n@media (max-width: 768px) {\n  /* 表格适配 */\n  .ant-table {\n    overflow-x: auto;\n    display: block;\n  }\n\n  /* 模态框宽度 */\n  .ant-modal {\n    width: 95% !important;\n    max-width: 100%;\n    margin: 10px;\n  }\n\n  /* 卡片布局 */\n  .user-card .ant-card-body {\n    padding: 12px;\n  }\n  \n  .user-card .ant-card-cover {\n    padding: 5px;\n  }\n}\n\n/* 手机端表格滚动 */\n.table-responsive {\n  overflow-x: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
